import ReceivingScreen from "components/mnl/lab/receiving/receivingScreen";

const TestRequestReceivingPage = () => {
  return <ReceivingScreen />;
};

export default TestRequestReceivingPage;
